// Corrected PaymentMethods Service
import {
  doc,
  setDoc,
  getDoc,
  updateDoc,
  deleteDoc,
  collection,
  query,
  where,
  getDocs,
  DocumentReference,
  Timestamp,
} from "firebase/firestore";
import { db } from "@firebase";
import { PaymentMethodsTypes } from "types";
import { COLLECTIONS } from "constant";
import { throwException } from "utils";

class PaymentMethods {
  // Create a new payment method
  async createPaymentMethod(
    data: PaymentMethodsTypes
  ): Promise<DocumentReference> {
    try {
      const docRef = doc(collection(db, COLLECTIONS.PAYMENT_METHODS));
      await setDoc(docRef, { ...data, id: docRef.id });
      return docRef;
    } catch (error) {
      console.error("Error creating payment method:", error);
      throw error;
    }
  }

  // Get all payment methods for a specific user
  async getPaymentMethodsByUser(
    userId: string
  ): Promise<PaymentMethodsTypes[]> {
    try {
      const q = query(
        collection(db, COLLECTIONS.PAYMENT_METHODS),
        where("userId", "==", userId)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as PaymentMethodsTypes[];
    } catch (error) {
      console.error("Error getting payment methods:", error);
      throw error;
    }
  }

  // Get all content items for a specific current user

  updatePaymentMethod = async (
    uid: string,
    updateData: Partial<PaymentMethodsTypes>
  ): Promise<void> => {
    try {
      console.log("updateContent", updateData);
      const contentRef = doc(db, COLLECTIONS.PAYMENT_METHODS, uid);
      await updateDoc(contentRef, updateData);
    } catch (error: any) {
      throw throwException(error.code || error.message);
    }
  };

  // Delete a payment method by ID
  async deletePaymentMethod(id: string): Promise<void> {
    try {
      const docRef = doc(db, COLLECTIONS.PAYMENT_METHODS, id);
      await deleteDoc(docRef);
    } catch (error) {
      console.error("Error deleting payment method:", error);
      throw error;
    }
  }
}

const PaymentMethodService = new PaymentMethods();
export { PaymentMethodService };
